if (!customElements.get('jc-faq')) {
  customElements.define(
    'jc-faq',
    class JCFaq extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('.jc-faq__item');
        this.tabs = this.querySelectorAll('.jc-faq__tab-input');

        this.handleTabChange = this.handleTabChange.bind(this);
        this.tabs.forEach((input) => input.addEventListener('change', this.handleTabChange));
      }

      handleTabChange() {
        const activeTab = [...this.tabs].find((input) => input.checked);
        const activeCategory = activeTab ? activeTab.value : '';

        this.items.forEach((item) => {
          item.hidden = activeCategory !== '' && item.dataset.category !== activeCategory;
        });
      }
    }
  );
}
